<template>
  <div class="projectHome">
    <el-card shadow="never" class="card-top">
      <el-button
        class="card-but"
        @click="activeName = 'first'"
        size="small"
        :type="activeName == 'first' ? 'primary' : 'text'"
      >
        <img
          v-if="activeName == 'first'"
          src="@/assets/home/select.png"
          alt=""
        />
        <img v-else src="@/assets/home/default.png" alt="" />
        <span v-if="activeName == 'first'">项目概况</span>
        <span v-else style="color:#666">项目概况</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'gk'"
        size="small"
        :type="activeName == 'gk' ? 'primary' : 'text'"
      >
        <img v-if="activeName == 'gk'" src="@/assets/home/select1.png" alt="" />
        <img v-else src="@/assets/home/default1.png" alt="" />
        <span v-if="activeName == 'gk'">构件厂概况</span>
        <span v-else style="color:#666">构件厂概况</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'mx'"
        size="small"
        :type="activeName == 'mx' ? 'primary' : 'text'"
      >
        <img v-if="activeName == 'mx'" src="@/assets/home/select2.png" alt="" />
        <img v-else src="@/assets/home/default2.png" alt="" />
        <span v-if="activeName == 'mx'">今日发货明细</span>
        <span v-else style="color:#666">今日发货明细</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'gjtj'"
        size="small"
        :type="activeName == 'gjtj' ? 'primary' : 'text'"
      >
        <img
          v-if="activeName == 'gjtj'"
          src="@/assets/home/select3.png"
          alt=""
        />
        <img v-else src="@/assets/home/default3.png" alt="" />
        <span v-if="activeName == 'gjtj'">构件统计</span>
        <span v-else style="color:#666">构件统计</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'sc'"
        size="small"
        :type="activeName == 'sc' ? 'primary' : 'text'"
      >
        <img v-if="activeName == 'sc'" src="@/assets/home/select5.png" alt="" />
        <img v-else src="@/assets/home/default5.png" alt="" />
        <span v-if="activeName == 'sc'">装配式构件生产</span>
        <span v-else style="color:#666">装配式构件生产</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'sl'"
        size="small"
        :type="activeName == 'sl' ? 'primary' : 'text'"
      >
        <img v-if="activeName == 'sl'" src="@/assets/home/select4.png" alt="" />
        <img v-else src="@/assets/home/default4.png" alt="" />
        <span v-if="activeName == 'sl'">装配式构件数量</span>
        <span v-else style="color:#666">装配式构件数量</span>
      </el-button>
      <el-button
        class="card-but"
        @click="activeName = 'tj'"
        size="small"
        :type="activeName == 'tj' ? 'primary' : 'text'"
      >
        <img v-if="activeName == 'tj'" src="@/assets/home/select3.png" alt="" />
        <img v-else src="@/assets/home/default3.png" alt="" />
        <span v-if="activeName == 'tj'">装配式构件出厂统计</span>
        <span v-else style="color:#666">装配式构件出厂统计</span>
      </el-button>
    </el-card>
    <div>
      <honmpage v-if="activeName == 'first'"></honmpage>
      <gkpage v-if="activeName == 'gk'"></gkpage>
      <mxpage v-if="activeName == 'mx'"></mxpage>
      <gjtjpage v-if="activeName == 'gjtj'"></gjtjpage>
      <gjsc v-if="activeName == 'sc'"></gjsc>
      <gjsl v-if="activeName == 'sl'"></gjsl>
      <cctj v-if="activeName == 'tj'"></cctj>
    </div>

    <el-dialog
      title="通知"
      :visible.sync="dialogVisible"
      width="45%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <p v-html="noticecontent.pjnc09"></p>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="disabled"
          type="primary"
          style="width: 200px"
          size="small"
          @click="guanNoRicw"
          >确定<span v-if="timeshow"> ( {{ time }} )</span></el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import honmpage from "./MenuConfigComponents/XUGK.vue";
import gkpage from "./MenuConfigComponents/GK.vue";
import mxpage from "./MenuConfigComponents/MX.vue";
import gjtjpage from "./MenuConfigComponents/GJTJ.vue";
import gjsc from "./MenuConfigComponents/GJSC.vue";
import gjsl from "./MenuConfigComponents/GJSL.vue";
import cctj from "./MenuConfigComponents/CCTJ.vue";
// import Icon from "../components/Icon.vue";
// import { GetNewProjectNotice } from "@/api/setAxios";
export default {
  components: {
    honmpage,
    gkpage,
    mxpage,
    gjtjpage,
    gjsc,
    gjsl,
    cctj,
  },
  data() {
    return {
      activeName: "first",
      dialogVisible: false,
      noticecontent: {},
      disabled: true,
      time: 3,
      timeshow: true,
    };
  },
  methods: {
    GetejectNotice() {
      let params = {
        xid: this.$store.state.project.projectId,
      };
      GetNewProjectNotice({ params }).then((res) => {
        if (res.Data) {
          this.noticecontent = res.Data;
          if (this.$store.state.project.noticeState == "") {
            this.$store.commit("project/SET_NOTICESTATE", "open");
            this.showNotice();
          }
        }
      });
    },
    guanNoRicw() {
      this.dialogVisible = false;
      this.$store.commit("project/SET_NOTICESTATE", "close");
    },
    showNotice() {
      if (this.$store.state.project.noticeState == "open") {
        this.dialogVisible = true;
        var timeInterval = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.timeshow = false;
            this.disabled = false;
            clearInterval(timeInterval);
          }
        }, 1000);
      }
    },
  },
  created() {
    // this.GetejectNotice();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  border-bottom: none;
}
/deep/ .el-card__header {
  border-bottom: none;
}
/deep/.el-dialog {
  border-radius: 10px;
}
/deep/.hardtext {
  margin-left: 16px;
  font-weight: bold;
  font-size: 15px;
  position: relative;
  top: 2px;
}
.card-top {
  position: relative;
  margin-bottom: 10px;
  height: 60px;
  .card-but {
    position: relative;
    top: -9px;
    min-width: 200px;
    padding-top: 8px;
  }
  span {
    font-size: 15px;
    padding-left: 5px;
    position: relative;
    top: 3px;
  }
  img {
    width: 20px;
  }
}
</style>
